import React from "react";
import { Outlet } from "react-router-dom";

const RelationClient = () => {
  return (
    <div className="d-flex flex-column">
      <Outlet />
    </div>
  );
};

export default RelationClient;
